import NotFound from '@src/components/NotFound'

interface Props {
  can: boolean
  element: React.ReactNode
}

const RouteGuard = ({ can, element }: Props) => {
  if (!can) {
    return <NotFound />
  }
  return element
}
export default RouteGuard
